import * as React from 'react'

import { cn } from '@/lib/utils'
import { LucideIcon } from 'lucide-react'

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & {
    startIcon?: LucideIcon
    endIcon?: LucideIcon | React.ReactNode
  }
>(({ className, type, ...props }, ref) => {
  const StartIcon = props.startIcon
  const EndIcon = props.endIcon
  return (
    <div className='relative w-full'>
      {StartIcon && (
        <div className='absolute top-1/2 left-1.5 -translate-y-1/2 transform'>
          <StartIcon size={16} className='text-muted-foreground' />
        </div>
      )}
      <input
        type={type}
        className={cn(
          'border-input bg-background ring-offset-background file:text-foreground placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium focus:bg-inherit focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
      {EndIcon && (
        <div className='absolute top-1/2 right-3 -translate-y-1/2 transform'>
          {typeof EndIcon === 'function' ? (
            <EndIcon size={18} className='text-muted-foreground' />
          ) : (
            EndIcon
          )}
        </div>
      )}
    </div>
  )
})
Input.displayName = 'Input'

export { Input }
